<template>
  <div
    @dragleave.prevent
    @dragover.prevent
    @drop.prevent
  >
    <Breadcrumbs
      :paths="['/' + get_prefix() + 'user', $route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.user.batch_user") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-stepper v-model="step" vertical class="mt-1">
      <v-stepper-step :complete="step > 1" step="1">
        {{ $t("message.batch_user.specify_parameter") }}
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-expansion-panels v-model="paramter_panel" accordion class="accordion">

          <!-- paramter_panel[0]: batch_user -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <v-row>
                  <v-col cols="4">
                    {{ $t("message.batch_user.select_file") }}
                  </v-col>
                  <v-col cols="8">
                    <span v-if="!open && $refs.upload && $refs.upload.files">
                      {{ $refs.upload.files.name }}
                    </span>
                    <span v-else-if="!open" class="text--secondary">
                      {{ $t("message.common.select_text") }}
                    </span>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content style="border:1px soild #000 !important">
              <Upload
                ref="upload"
                type="batch_user"
                :valid="files_valid"
                :multiple="false"
                :max_files="1"
                v-on:update_files="files = $event"
                v-on:update_files_valid="files_valid = $event"
                v-on:done_upload="done_upload"
                :upload_detail="upload_detail_parm"
              >
              </Upload>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- paramter_panel[1]: output_lang -->
          <v-expansion-panel>
            <v-expansion-panel-header>
              <template v-slot:default="{ open }">
                <v-row>
                  <v-col cols="4">
                    {{ $t("message.batch_user.output_lang") }}
                  </v-col>
                  <v-col cols="8">
                    <span v-if="!open">
                      {{ $t('message.common.lang_' + parameters.output_lang) }}
                    </span>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content style="border:1px soild #000 !important">
              <v-select
                :items="output_langs"
                item-text="label"
                item-value="value"
                v-model="parameters.output_lang"
              >
                <template v-slot:item="props">
                  {{ $t('message.common.lang_' + props.item.label) }}
                </template>
                <template v-slot:selection="props">
                  {{ $t('message.common.lang_' + props.item.label) }}
                </template>
              </v-select>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card flat class="pt-5">
          <p class="text-right">
            <v-btn
              color="primary"
              :disabled="files_valid || executing"
              @click="upload_file()"
            >
              {{ $t("message.common.execute") }}
            </v-btn>
            <v-btn :to="'/' + get_prefix() + 'user'">
              {{ $t("message.common.prev") }}
            </v-btn>
          </p>
        </v-card>
      </v-stepper-content>

      <v-stepper-step :complete="step > 2" step="2">
        {{ $t("message.common.complete") }}
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-card>
            <v-card-text>
            {{ $t("message.common.upload_success") }}
            <v-list v-for="job in jobs" :key="job.jid">
              <v-list-item dense :to="'/job/' + job.jid">
                <v-list-item-icon>
                  <v-icon>
                    mdi-link-variant
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ job.jid }}:&nbsp;{{ job.name }}({{ job.source }})
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card flat class="pt-5">
          <p class="text-right">
            <v-btn :to="'/' + get_prefix() + 'user'">
              {{ $t("message.common.prev") }}
            </v-btn>
          </p>
        </v-card>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import Upload from '../components/Upload';
import { http_error } from "../js/http_error";

export default {
  name: 'user_batch',
  components: {
    Breadcrumbs,
    Upload
  },
  mixins: [http_error],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "2B",
      step: 1,
      executing: false,
      paramter_panel: 0,
      parameters: {
        "title": null,
        "batch_user": null,
        "output_lang": this.$i18n.locale
      },
      files: [],
      files_valid: true,
      sources: [],
      jobs: [],
      upload_detail_parm:{
        target: 'batch_user',
        additional: false,
        size: 300,
        count: 200000,
        files: 1,
        template: "../../static/batch_user_" + this.mode + "_{lang}.xlsx"
      }
    }
  },
  methods: {
    upload_file: function(){
      this.executing = true;
      this.$refs.upload.upload();
    },
    done_upload: function(success){
      if(success){
        if(this.$store.getters.debug){
          console.log(this.sources);
        }
        for(var file of this.$refs.upload.uploading_files){
          if(this.$store.getters.debug){
            console.log(file);
          }
          this.sources.push({
            fid: file.fid,
            name: file.file_name
          });
        }
        this.execute_second();
      }else{
        this.$router.push('/' + this.get_prefix() + 'user');
      }
    },
    execute_second: function(){
      if(this.$store.getters.debug){
        console.log(this.sources);
      }
      this.jobs = [];
      for(var source of this.sources){
        var job = {
          "source": source.fid,
          "name": source.name,
          "status": "uploading",
          "jid": null,
        };
        var take_over = {
          "job": job,
          "parent": this
        };
        var parameters = Object.assign({}, this.parameters);
        parameters.batch_user = source.fid;
        parameters.title = source.name + "(" + source.fid + ")";
        this.$http.post(this.$store.getters.api_endpoint + "/" + this.get_prefix() + "action/batch_user",
                        parameters,
                        {
                          headers: {
                            'Content-Type': 'application/json'
                          },
                        })
          .then(function(response){
            this.status = "complete";
            this.jid = response.data.jid;
          }.bind(job) )
          .catch(function(error){
            this.job.status = "error";
            if(this.parent.http_error(error)){
              this.parent.$store.commit("setNotification", {
                type: "error",
                message: error.response.data
              });
            }
          }.bind(take_over));
        this.jobs.push(job);
      }
    },
    get_prefix: function(){
      if(this.mode === "user"){
        return "";
      }else{
        return this.mode + "/";
      }
    }
  },
  computed: {
    output_langs: function(){
      var langs = [];
      for(var lang of Object.keys(this.$store.getters.langs)){
        langs.push({
          label: lang,
          value: lang
        });
      }
      return langs;
    }
  },
  watch: {
    jobs: {
      handler: function (val, oldVal) {
        var is_complete = true;
        for(var job of val){
          if(!job.jid){
            is_complete = false;
            break;
          }
        }
        if(is_complete){
          this.step = 2;
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.accordion{
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.v-expansion-panel::before{
  box-shadow: none;
}
</style>
